/**
 * Whether this tenant has Stripe keys in system_settings.
 * Falls back to false (hide Stripe) if the check fails.
 */
export async function fetchIsStripePaymentConfigured(supabaseClient) {
  try {
    const { data, error } = await supabaseClient.rpc('is_stripe_payment_configured')
    if (error) {
      console.warn('is_stripe_payment_configured failed:', error.message)
      return false
    }
    return data === true
  } catch (err) {
    console.warn('is_stripe_payment_configured error:', err)
    return false
  }
}
